import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HistogramChartComponent } from './histogram-chart.component';
import type { HistogramDisplayConfig, HistogramParams } from './histogram-chart.model';

@Component({
  selector: 'dojo-histogram-explain',
  standalone: true,
  imports: [HistogramChartComponent],
  template: `<dojo-histogram-chart [params]="params()" [display]="display()" />`,
  host: { class: 'block w-full h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistogramExplainComponent {
  readonly params = input.required<HistogramParams>();
  readonly display = input<HistogramDisplayConfig>({});
}
